<template>
  <WdsStack :class="`tw-p-4 tw-flex ${status === 'warning' ? 'tw-bg-orange-50' : ''}`">
    <WdsStack
      class="tw-flex-1 tw-flex-wrap lg:tw-flex-nowrap"
      gap-sm
      align-center
      justify-space-between
    >
      <WdsStack gap-sm align-start>
        <WdsStack align-center>
          <WdsIcon
            :name="icon"
            :size="20"
            class="tw-mt-0.5"
            :color="status === 'warning' ? '#E76C0D' : '#5D36F1'"
          />
        </WdsStack>

        <WdsStack direction-column>
          <WdsText large>
            <span :class="status === 'warning' ? 'tw-text-orange-600' : 'tw-text-indigo-500'">
              {{ title }}
            </span>
          </WdsText>

          <WdsText v-if="description">
            <span class="tw-text-gray-800">{{ description }}</span>
          </WdsText>
        </WdsStack>
      </WdsStack>
      <WdsButton
        v-if="buttonText || href || action"
        :href="href"
        :secondary="status === 'none'"
        :primary="status === 'warning'"
        lg
        @click="handleClick"
      >
        <WdsStack class="tw-w-full" gap-sm align-center justify-center>
          <div class="tw-whitespace-nowrap">{{ buttonText }}</div>
          <div>
            <WdsIcon
              :name="WdsIconNameEnum.CHEVRON_RIGHT"
              :size="16"
              weight="thin"
              stroke="white"
            />
          </div>
        </WdsStack>
      </WdsButton>
    </WdsStack>
  </WdsStack>
</template>

<script lang="ts" setup>
import { WdsButton, WdsIcon, WdsIconNameEnum, WdsStack, WdsText } from '@worksome/wds-components'

const props = defineProps<{
  title: string
  icon: WdsIconNameEnum
  description?: string
  href?: string
  action?: () => void
  buttonText?: string
  status?: 'warning' | 'none'
}>()

const handleClick = () => {
  if (!props.href && props.action) {
    props.action()
  }
}
</script>
